import './Intro.css'

const Intro = () => {
  return (
    <div className='background-container'>
      <div className="row">
        <div className="col-md-6">
          <div className='intro-text'>Empowering</div>
          <div className='intro-text'>the most exclusive</div>
          <div className='intro-text color-change'>Shopify stores</div>
        </div>
        <div className="col-md-6">
        </div>
      </div>
    </div>
  );
}

export default Intro;
